import { SelectOption } from '@frontend/components/basic-forms';
import { FunctionalityEnumClient } from '@frontend/functionality/api';
import { Feature } from '@frontend/functionality/types';
import { useEffect, useState } from 'react';

import { FeatureSelectProps } from './feature-select.component';

interface ViewProps {
    options: SelectOption<Feature>[];
}

const useFeatureSelect = (props: FeatureSelectProps): ViewProps => {
    const [options, setOptions] = useState<SelectOption<Feature>[]>([]);

    useEffect(() => {
        const fetchOptions = async () => {
            const apps = await FunctionalityEnumClient.fetchFeatures();
            setOptions(apps.map((c) => ({ label: c.replace(/_/g, ' '), value: c })));
        };
        fetchOptions();
    }, []);

    return { options };
};

export default useFeatureSelect;
